import { useRouter } from 'next/router'
import { paths } from '@mc/paths'
import type { Category } from '../types'
import { CategoryNavIconItem } from './CategoryNavIconItem'
import { CategoryNavPillItem } from './CategoryNavPillItem'

type CategoryNavItemWrapperProps = {
  category: Category
  slug?: string
  pathCategory: (slug: string) => string
  onNavClick?: (category: Category) => void
}

export const CategoryNavItemWrapper = ({
  category,
  slug,
  pathCategory,
  onNavClick,
}: CategoryNavItemWrapperProps) => {
  const { pathname } = useRouter()

  if (pathname.includes(paths.articles)) {
    return (
      <CategoryNavPillItem
        category={category}
        slug={slug}
        pathCategory={pathCategory}
        onNavClick={onNavClick}
      />
    )
  }

  return (
    <CategoryNavIconItem
      category={category}
      slug={slug}
      pathCategory={pathCategory}
      onNavClick={onNavClick}
    />
  )
}
